import angular from 'angular';
import MenuToggleComponent from './menu-toggle.component';

let MenuToggleModule = angular.module('shared.components.menuToggle', [])
  .component('menuToggle', MenuToggleComponent);

export default MenuToggleModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/menu-toggle/menu-toggle.js
 **/